export const BASE_URL = "/stark";
export const LOGIN = {
  password: "guest",
  username: "guest",
};
